import { useState, useMemo, useContext } from 'react'
import moment from 'moment-timezone'
import { enqueueSnackbar } from 'notistack'

import { Typography, FormLabel, TextField, Button } from '@mui/material'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'

import { AppContext } from '/providers/app-context'
import { changeEventDate } from '/providers/studio-api'

import StyledPaper from '/components/paper'

const EventEditor = ({ template }) => {

  const { apiSource, apiKey, refreshTemplates, setProcessing } = useContext(AppContext)

  const now = moment()
  const originalEventDate = moment(template.instance_data.__event_date__, "YYYYMMDDHHmmSS")

  const [notification, setNotification] = useState("")
  const [eventDate, setEventDate] = useState(originalEventDate)

  const unchanged = useMemo(() => {
    if (originalEventDate.isSame(eventDate)) return true

    // Must provide a notification message!
    if (!notification.length) return true

    return false
  }, [notification, eventDate])

  const updatePasses = async () => {
    const newEventDate = eventDate.format("YYYYMMDDHHmmSS")
    const newExpiryDate = eventDate.add(3, "day").format("YYYYMMDDHHmmSS")

    setProcessing(true)
    enqueueSnackbar({ message: 'Updating and notifying passes', variant: 'light' })
    // TODO handle error
    await changeEventDate({ apiSource, apiKey, templateId: template.id, notification, newEventDate, newExpiryDate, })
    enqueueSnackbar({ message: 'Updates and notifications queued', variant: 'success' })
    setProcessing(false)
    setNotification("")
    refreshTemplates()
  }

  return (
    <>
      <StyledPaper classes="mt-5">
        <Typography variant="h5">Amend event date / time</Typography>
        <div className='text-gray-300 italic'>If your event date or time changes then use this form to update all of your issued passes and notify your ticket holders.</div>

        <div className='flex flex-col gap-5 w-full mt-5'>

          <div>
            <FormLabel id="ticket_types">Event Date & Time</FormLabel>
            <div className='flex flex-row gap-5 justify-start'>
              <DateCalendar value={eventDate} onChange={date => setEventDate(date)} minDate={now} format='DD/MM/YYYY' />
              <TimePicker value={eventDate} onChange={date => setEventDate(date)} ampm={false} />
            </div>
          </div>

          <div>
            <TextField label="Notification" value={notification} onChange={e => setNotification(e.target.value)} fullWidth slotProps={{ inputLabel: { shrink: true } }} helperText="A notification message is required" />
          </div>

          <div className='self-end'>
            <Button variant="contained" onClick={updatePasses} disabled={unchanged}>Update Passes</Button>
          </div>

        </div>

      </StyledPaper>
    </>
  )
}

export default EventEditor